import React from "react";
import { Link } from "react-router-dom";

import maintain from "../../assets/images/maintanance.svg"

const Maintenance = () => {
  return (
    <React.Fragment>
      <section className="min-h-[calc(100vh-134px)] flex items-center justify-center">
        <div className="max-w-[1440px] mx-auto text-center px-4">
          <div className="space-y-5">
            <h2 className="text-3xl font-bold md:text-5xl dark:text-white">
              Site is Under Maintenance
            </h2>
            <img
              src={maintain}
              className="mx-auto sm:max-w-xs"
              alt=""
            />
            <p className="text-base text-muted dark:text-darkmuted">
              Need support?
            </p>
            <Link to="#" className="text-purple">
              no-reply@domain.com
            </Link>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Maintenance;
